<template>
  <div class="bg-sub2">
    <div class="container header-page">
      <div class="" v-if="history.length">
        <h4 class="header-history"><i class="fa fa-fighter-jet"></i> ประวัติการเข้าชม</h4>
        <div class="" v-for="video in history">
          <div class="delete-favorite" @click="DeleteHistory(video)">
            <fa icon="trash" class="icon-favorite"/>
          </div>
          <div class="box-history"  @click="PlayVideoHistory(video)">
            <div class="video-history">
              <figure class="sixteen-nine-img float-left thumb-history">
                <p class="duration">{{video.duration}}</p>
                <img :src="video.thumb" >
                <div class="btn-overlay">
                  <fa icon="play" class="icon-play"/>
                </div>
              </figure>
            </div>
            <div class="detail-history">
              <h5 class="title-history">{{video.name}}</h5>
              <p class="channal-history">{{video.desc}}</p>
            </div>
          </div>
        </div>

      </div>

      <div class="container notfound text-center" v-if="!history.length">
        <img src="../../src/assets/img/finallogo.png" alt="" class="img-category">
        <h3 class="text-category">คุณไม่มีประวัติการเข้าชม</h3>
      </div>
    </div>
  </div>


</template>

<script>
import config from '../config';
import axios from 'axios';
const Host = config.app.Host;
import {
  Fa
} from 'mdbvue';
export default {
  name: 'HistoryPage',
  components: {
    Fa
  },
  data() {
    return {
      history: []
    };
  },
  mounted() {
    this.GetHistory();
    this.ToggleLogin();
    localStorage.pincode = '';
    this.Session();
  },
  methods: {
    DeleteHistory(data) {
      let APIgetDeleteHistory = Host + '/api/v1/history/delete';
      axios.post(APIgetDeleteHistory , {
        email: localStorage.emailfront,
        videoid: data.id
      }).then(response => {
        this.GetHistory();
      });
    },
    Session() {
      let APIgetSession = Host + '/api/v1/member/session';
      axios.post(APIgetSession , {
        token: localStorage.token
      }).then(response => {
        if (response.data.code !== '200') {
          localStorage.emailfront = '';
          localStorage.token = '';
          localStorage.auth = 'false';
        }
      });
    },
    ToggleLogin() {
      if (localStorage.auth == 'false' || !localStorage.auth) {
        this.$router.push('/');
      }
      this.modalLogin = true;
    },
    GetHistory() {
      let APIgetHistory = Host + '/api/v1/history';
      axios.post(APIgetHistory , {
        email: localStorage.emailfront
      }).then(response => {
        this.history = response.data.result;
      });
    },
    PlayVideoHistory(data) {
      document.location.assign('/#/vod/' + data.id);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }
};
</script>

<style>

</style>
